import { uri } from '../../api-endpoint';
import {
  ICompanyAPIValidationError,
  ICompanyFromAPISuccessResponse
} from '../../type-conversion/company/from-api-repsonse';
import { CompanyAPIRequestBody } from '../../type-conversion/company/to-api-request-body';
import { createTemplateFn } from '../common';

export const createCompany = (token: string) =>
  createTemplateFn(
    token,
    uri.companyList(),
    CompanyAPIRequestBody,
    ICompanyFromAPISuccessResponse,
    ICompanyAPIValidationError
  );
